import classNames from 'classnames'
import { Heading, IconButton, LayoutStack } from 'design-system/client'
import { useCallback, useEffect, useState } from 'react'
import Cookies, { CookieChangeListener } from 'universal-cookie'
import styles from './QuickLinks.module.css'
const cookies = new Cookies()

export const QUICK_LINKS_PORTAL_ID = 'quick-links-portal'

export function useIsBackofficeUser() {
  const [isBackofficeUser, setIsBackofficeUser] = useState(false)
  const handleCookieChange: CookieChangeListener = useCallback(() => {
    const isBackofficeUser = !!cookies.get('betterplace_backoffice_user')
    if (isBackofficeUser) {
      setIsBackofficeUser(true)
      return
    }
    setIsBackofficeUser(false)
  }, [])

  useEffect(() => {
    const isBackofficeUser = !!cookies.get('betterplace_backoffice_user')
    // this is needed for avoiding hydration errors
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsBackofficeUser(isBackofficeUser)
    cookies.addChangeListener(handleCookieChange)
    return () => {
      cookies.removeChangeListener(handleCookieChange)
    }
  }, [handleCookieChange])
  return isBackofficeUser
}

function QuickLinksPortal() {
  const [isOpen, setIsOpen] = useState(false)
  const isBackofficeUser = useIsBackofficeUser()
  const showOverlay = isBackofficeUser || process.env.NEXT_PUBLIC_REVISION === 'dev'
  if (!showOverlay) return null

  return (
    <>
      <IconButton
        iconName="link"
        className={classNames(styles.floatingButton, { [styles.hidden!]: isOpen })}
        onClick={() => setIsOpen(true)}
        aria-label="open quick links"
      />

      <div
        style={{ display: isOpen ? 'block' : 'none' }}
        className={styles.backdrop}
        role="none"
        onClick={() => setIsOpen(false)}
        onKeyDown={(e) => {
          if (e.key !== 'Enter') return
          setIsOpen(false)
        }}
      >
        <div
          className={styles.container}
          role="presentation"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Heading level="heading-sm" className={styles.heading}>
            Quick Links
          </Heading>
          <IconButton
            iconName="x"
            kind="plain"
            className={styles.closeButton}
            iconProps={{ color: 'fg-content-primary' }}
            onClick={() => setIsOpen(false)}
            aria-label="close quick links"
          />
          <LayoutStack id={QUICK_LINKS_PORTAL_ID}></LayoutStack>
          <p className={styles.revision}>
            Revision: <code>{(process.env.NEXT_PUBLIC_REVISION ?? 'unknown').substring(0, 7)}</code>
          </p>
        </div>
      </div>
    </>
  )
}

export default QuickLinksPortal
